<template>
  <div class="bookmark-container" >
    <p>我的收藏</p>
    <Tabs v-model="active_tab" class="bookmark-tab" :animated="false">

      <TabPane label="快讯" name="0" :style="{'min-height':height+'px'}">
        <div class="news-list" v-if="list0.length != 0">
          <div class="news-item" v-for="(item, index) in list0" :key="item.id">
            <router-link :to="$store.state.index2_path + '/NewsDetail/' + item.uid" class="title" target="_blank">{{item.title}}</router-link>
            <div>
              <p>话题类别： <span v-for="tag in returnMetaArr('news_topic_type',item.type)" :key="tag.id">{{tag.name}}</span> </p>
              <p>{{item.create_time}} <i class="iconfont s" title="取消收藏" @click="ask('0', item.id ,index)">&#xe66f;</i> </p>
            </div>
          </div>
          <div class="more-button" v-if="show_more0" @click="changePage">
            <div>
              加载更多
            </div>
          </div>
        </div>
        <defaultPage v-else>
          <p slot="p">您目前没有收藏任何快讯，不如去随便逛逛
            <br />看看有什么内容值得收藏起来，反复品读<br /><router-link :to="{ name: 'NewsList' }">去快讯列表看看</router-link> </p>
        </defaultPage>
        <Spin fix v-if="spinShow0">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </TabPane>

      <TabPane label="专题" name="2" :style="{'min-height':height+'px'}">
        <div class="report-list" v-if="list2.length != 0">
          <div class="report-item" v-for="(item, index) in list2" :key="item.id">
            <div class="img">
              <div @click="go(item, '3')">
                <img class="logo" :src="$store.state.img_req_url + item.share_logo_path">
              </div>
              <img :src="$store.state.static_img_url + 'pic/list/u-li-type-1.png'" class="u-li-type">
            </div>
            <div class="right">
              <div>
                <a href="javascript:void(0)" @click="go(item, '3')" class="title">{{item.title}}</a>
                <a href="javascript:void(0)" @click="go(item, '3')" class="desc">{{item.summary}}</a>
              </div>
              <div>
                <div>
                  <p class="type">专题类别： <span v-for="tag in returnMetaArr('theme_type',item.type)" :key="tag.id">{{tag.name}}</span> </p>
                  <a v-if="compareTime(item)" href="javascript:void(0)" class="link" @click="contentRouter(item.latest_content[0])">{{item.latest_content[0].publish_time | time_standard}}更新：{{item.latest_content[0].title}}</a>
                </div>
                <p class="time">{{item.create_time}} <i class="iconfont s" title="取消收藏" @click="ask('2', item.id ,index)">&#xe66f;</i> </p>
              </div>
            </div>
          </div>
          <div class="more-button" v-if="show_more2" @click="changePage">
            <div>
              加载更多
            </div>
          </div>
          <!-- <p class="no-more-p" v-else>亲，您收藏的专题已加载完。</p> -->
        </div>
        <defaultPage v-else>
          <p slot="p">您目前没有收藏任何专题，不如去随便逛逛
            <br />看看有什么内容值得收藏起来，反复品读<br /><router-link :to="{ name: 'SpecialList' }">去专题列表看看</router-link> </p>
        </defaultPage>
        <Spin fix v-if="spinShow2">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </TabPane>

      <TabPane label="报告" name="1" :style="{'min-height':height+'px'}">
        <div class="special-list" v-if="list1.length != 0">
          <div class="special-item" v-for="(item, index) in list1" :key="item.id">
            <div class="img" @click="go(item, '2')">
              <div>
                <img class="logo" :src="$store.state.img_req_url+item.logo_path">
              </div>
              <img :src="$store.state.static_img_url + 'pic/list/u-li-type-2.png'" class="u-li-type">
            </div>
            <div class="right">
              <div>
                <a href="javascript:void(0)" @click="go(item, '2')"  class="title">{{item.title}}</a>
                <a href="javascript:void(0)" @click="go(item, '2')"  class="desc">{{item.summary}}</a>
              </div>
              <div>
                <div>
                  <p class="type">报告分类： <span v-for="tag in returnMetaArr('report_type',item.category_id)" :key="tag.id">{{tag.name}}</span> </p>
                </div>
                <p class="time">{{item.create_time}} <i class="iconfont s" title="取消收藏" @click="ask('1', item.id ,index)">&#xe66f;</i> </p>
              </div>
            </div>
          </div>
          <div class="more-button" v-if="show_more1" @click="changePage">
            <div>
              加载更多
            </div>
          </div>
          <!-- <p class="no-more-p" v-else>亲，您收藏的报告已加载完。</p> -->
        </div>
        <defaultPage v-else>
          <p slot="p">您目前没有收藏任何报告，不如去随便逛逛
            <br />看看有什么内容值得收藏起来，反复品读<br /><router-link :to="{ name: 'ReportList' }">去报告列表看看</router-link> </p>
        </defaultPage>
        <Spin fix v-if="spinShow1">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </TabPane>

      <TabPane label="政策" name="3" :style="{'min-height':height+'px'}">
        <div class="policy-list" v-if="list3.length != 0">
          <div class="policy-item" v-for="(item, index) in list3" :key="item.id">
            <p class="p1" @click="go(item, '4')"><span>政策</span>{{item.name}}</p>
            <div class="item-last-row">
              <p class="p2">
                  <span><i class="iconfont">&#xe632;</i>发文时间：{{item.publish_time | time_standard}}</span>
                  <span v-if="item.address_id && item.address_id != '0'"><i class="iconfont">&#xe62c;</i>有效地区：{{item.address_id | addressDeal('3', $store.state.address)}}</span>
                  <span v-if="item.publish_org"><i class="iconfont">&#xe633;</i>发文机关：{{item.publish_org}}</span>
              </p>
              <p class="time">{{item.create_time}} <i class="iconfont s" title="取消收藏" @click="ask('3', item.id ,index)">&#xe66f;</i></p>
            </div>
          </div>
          <div class="more-button" v-if="show_more3" @click="changePage">
            <div>
              加载更多
            </div>
          </div>
        </div>
        <defaultPage v-else>
          <p slot="p">您目前没有收藏任何政策，不如去随便逛逛
            <br />看看有什么内容值得收藏起来，反复品读
          </p>
        </defaultPage>
        <Spin fix v-if="spinShow3">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </TabPane>

      <TabPane label="文章" name="4" :style="{'min-height':height+'px'}">
        <div class="article-list" v-if="list4.length != 0">
          <div class="article-item" v-for="(item, index) in list4" :key="item.id">
              <div class="article-img" @click="go(item, '5')">
                  <img :src="item.logo_path | logo_show" />
              </div>
              <div class="article-info">
                  <div class="article-title" @click="go(item, '5')">{{item.title}}</div>
                  <div class="article-summary" @click="go(item, '5')">{{item.summary}}</div>
                  <div class="article-dec">
                      <img :src="item.author_logo_path | logo_show" class="header-img"/>
                      <span class="author">{{item.author_name}}</span>
                      <span class="time">{{item.publish_time | time_standard}}</span>
                      <div class="collect_share">
                        {{item.create_time}}
                        <i class="iconfont s" title="取消收藏" @click="ask('4', item.id ,index)">&#xe66f;</i>
                      </div>
                  </div>
              </div>
          </div>
          <div class="more-button" v-if="show_more4" @click="changePage">
            <div>
              加载更多
            </div>
          </div>
        </div>
        <defaultPage v-else>
          <p slot="p">您目前没有收藏任何文章，不如去随便逛逛
            <br />看看有什么内容值得收藏起来，反复品读
          </p>
        </defaultPage>
        <Spin fix v-if="spinShow4">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </TabPane>

    </Tabs>
    <Modal
      class="message-model"
      title="提示"
      v-model="message_model"
      ok-text="确认"
      cancel-text="取消"
      @on-ok="cancelCollect(content_type, content_id, collectCb, cb_param, true)"
      >
      <p>亲，取消收藏后，不再记录该信息，是否取消？</p>
    </Modal>
    <!-- <Spin fix v-if="spinShow">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin> -->
  </div>
</template>

<script>
import {
  userFavorite, getMeta
} from '../../service'
import defaultPage from './components/default'
import {
  userInfo
} from 'js/userInfo'
import {
  user_main_mixin
} from 'js/user_main_mixin'
import { collect_mixin } from 'js/collect_mixin.js'
// 1快讯（默认），2报告，3专题(latest_content)
export default {
  mixins: [userInfo, user_main_mixin, collect_mixin],
  inject: ['returnMetaArr', 'cancelCollect'],
  props: ['collectTyoe'],
  data() {
    return {
      height: 0,
      active_tab: '0',
      spinShow0: true,
      spinShow1: true,
      spinShow2: true,
      spinShow3: true,
      spinShow4: true,
      message_model: false,
      content_type: '',
      content_id: '',
      cb_param: {
        type: '',
        index: ''
      },
      // 快讯tab
      show_more0: true, // 是否显示加载更多
      list0: [],
      page0: 1,
      // 专题tab
      show_more1: true,
      list1: [],
      page1: 1,
      // 收藏tab
      show_more2: true,
      list2: [],
      page2: 1,
      // 政策tab
      show_more3: true,
      list3: [],
      page3: 1,
      // 文章tab
      show_more4: true,
      list4: [],
      page4: 1,
      dynview_tag: [],
      report_type: [],
      news_topic_type: [],
      theme_type: []
    }
  },
  components: {
    defaultPage
  },
  methods: {
    async getMeta() {
      let res = await getMeta({
        name: ['dynview_tag','report_type','news_topic_type','theme_type']
      }, (error) => {this.$Message.error('元数据请求错误')})
      if (res.status == 'success') {
        this.dynview_tag = res.meta.dynview_tag
         this.report_type = res.meta.report_type
        this.news_topic_type = res.meta.news_topic_type
        this.theme_type = res.meta.theme_type
      } else {
        this.$Message.error(res.message)
      }
    },
    async userFavorite(type) {
      console.log(this['page' + this.active_tab])
      let temp_type = type || this.active_tab
      let res = await userFavorite({
        user_key: this.$store.state.user_key,
        page: this['page' + this.active_tab],
        type: temp_type
      }, (error) => {
        this.$Message.error('请求错误')
      })
      if (res.status == 'success') {
        this['list' + temp_type] = [...this['list' + temp_type], ...res.res]
        if (res.res.length < 10) {
          this['show_more' + temp_type] = false
        }
        this['spinShow' + type] = false
      } else {
        this.$Message.error(res.message)
      }
    },
    returnMetaArr(type, tag_string) { // 返回关联的元数据数组(元数据类型，tag字符串)
      if (!tag_string) {
        return []
      } else {
        let tag_arr = tag_string.split(',')
        return this[type].filter((item)=>{
          return tag_arr.indexOf(item.id) != -1
        })
      }
    },
    changePage() {
      this['page' + this.active_tab] = this['page' + this.active_tab] + 1
      this.userFavorite()
    },
    ask(type, id, index) { // 弹出询问框
      this.content_type = type
      this.content_id = id
      this.cb_param.type = type
      this.cb_param.index = index
      this.message_model = true
    },
    collectCb(obj) { // 刷新列表(0快讯， 1报告，2专题)
      this['list' + obj['type']].splice(obj['index'], 1)
    },
    contentRouter(news) {
      if (news.content_type == '0') { // 0是文章
        window.open((process.env.NODE_ENV == 'development' ? 'http://192.168.1.104:8003/index.php/' : 'https://vcbeat.top/') + window.btoa(news.uid))
      } else if (news.content_type == '1') { // 1是快讯
        window.open((process.env.NODE_ENV == 'development' ? 'http://192.168.1.104:8081/newsDetail/' : this.$store.state.index2_path+'/newsDetail/') + news.uid)
      } else if (news.content_type == '5') { // 1是政策
        window.open((process.env.NODE_ENV == 'development' ? 'http://192.168.1.104:8081/policyDetail/' : this.$store.state.req_url+'/policyDetail/') + news.uid)
      }
    },
    handleClickTags(item) {
      if(process.env.NODE_ENV == 'development') {
        window.open('http://192.168.1.104:8003/Article/labelList/keyword/' + item)
      } else {
        window.open('https://vcbeat.top/Article/labelList/keyword/' + item)
      }
    },
    compareTime(item) {
      if (item.latest_content.length == 0) {
        return false
      } else {
        return moment(item.latest_content[0].publish_time).isAfter(item.create_time)
      }
    }
  },
  created() {
    this.getMeta()
    this.active_tab = this.$route.query.type ? this.$route.query.type : '0'
    this.userFavorite('0')
    this.userFavorite('1')
    this.userFavorite('2')
    this.userFavorite('3')
    this.userFavorite('4')
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 222
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/userMain.stylus'
ellipsis()
  display: -webkit-box
  overflow: hidden
  text-overflow: ellipsis
  word-break: break-all
  -webkit-box-orient: vertical
commonBgColor1(color_d, color_l)
  [data-theme='dark'] & {
    background: color_d !important
  }
  [data-theme='light'] & {
    background: color_l !important
  }
commonColor1(color_d, color_l) // 字体颜色
  [data-theme='dark'] & {
    color: color_d !important
  }
  [data-theme='light'] & {
    color: color_l !important
  }
commonBorderColor1(color_d, color_l) // 背景
  [data-theme='dark'] & {
    border-color: color_d !important
  }
  [data-theme='light'] & {
    border-color: color_l !important
  }
.bookmark-container
  width: 1200px
  margin: 0 auto
  padding: 30px 0 20px
  > p
    margin-bottom: 20px
    commonColor(#FFFFFF, #333333)
    font-size: 18px
    font-weight: 500
    span
      commonColor(#BCBDC1, #999999)
      font-size: 14px
      i
        color: rgba(250, 122, 80, 1)
        font-style: normal
  >>>.ivu-tabs-nav-scroll
    commonBgColor(#2A2F42, #FFFAF5)
    .ivu-tabs-tab
      width: 200px;
      commonColor( #BCBDC1, #999)
      text-align: center;
      padding: 15px 16px;
      &.ivu-tabs-tab-active
        commonBgColor(#1F2330, #ffffff);
        commonColor(#fff, #333);
    .ivu-tabs-ink-bar
      top: 1px;
      background-color: rgba(250, 122, 80, 1)
  >>>.ivu-tabs-bar
    margin-bottom: 0;
  >>>.ivu-tabs-content
    commonBgColor(#1F2330, #fff)
    padding: 10px 30px
    position: relative
.bookmark-container
  position: relative;
  .news-list
    .news-item
      padding: 20px 0;
      .title
        height: 40px;
        font-size: 16px;
        commonColor(#ffffff, #333333)
        line-height:20px;
        -webkit-line-clamp: 2;
        font-weight: bold;
        &:hover
          color: rgba(250, 122, 80, 1);
      >div
        margin-top: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        p
          font-size: 12px;
          commonColor(#797B83, #999999)
        p:nth-child(1)
          span+span
            margin-left: 6px;
      &+.news-item
        border-top: 1px solid;
        commonBorderColor(#40444F, #f3f3f3)
  .special-list, .report-list
    .special-item, .report-item
      display: flex;
      padding: 20px 0;
      .img
        position: relative;
        margin-right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 216px;
        height: 126px;
        cursor: pointer;
        >div
          overflow: hidden;
          font-size: 0
        .u-li-type
          position: absolute
          top: 4px
          right: -4px
        .logo
          height: 126px;
          transition: all .3s;
          width: 216px;
          &:hover
            transform: scale(1.2);
        .icon
          position: absolute;
          top: -7px;
          left: -6px;
      .right
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title
          font-size: 16px;
          commonColor(#ffffff, #333333)
          height: 20px;
          line-height: 20px;
          ellipsis();
          -webkit-line-clamp: 1;
          font-weight: bold;
          &:hover
            color: rgba(250, 122, 80, 1)
        .desc
          margin-top: 14px;
          font-size: 14px;
          commonColor(#BCBDC1, #666666)
          height: 40px;
          line-height: 20px;
          ellipsis();
          -webkit-line-clamp: 2;
          &:hover
            color: rgba(250, 122, 80, 1)
        >div:nth-child(2)
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          .type
            font-size: 12px;
            commonColor(#797B83, #999999)
            margin-bottom: 3px;
            span
              commonColor(#949AA2, #999999)
            span+span
              margin-left: 6px;
          a
            font-size: 12px;
            color: rgba(250, 122, 80, 1);
            margin-top: 12px;
            ellipsis();
            height: 14px;
            line-height: 14px;
            -webkit-line-clamp: 1;
            max-width: 370px;
          .time
            commonColor(#797B83, #999999)
            font-size: 12px;
    .special-item+.special-item, .report-item+.report-item
      border-top: 1px solid;
      commonBorderColor(#40444F, #f3f3f3)
  .policy-list
    .policy-item
      padding: 20px 0
      &+.policy-item
        border-top: 1px solid;
        commonBorderColor(#40444F, #f3f3f3)
      .p1
        font-size:16px
        commonColor(#FFFFFF, #333333)
        cursor: pointer
        font-weight: 600
        line-height: 20px
        height: 20px
        display: -webkit-box
        overflow: hidden
        text-overflow: ellipsis
        word-break: break-all
        -webkit-box-orient: vertical
        -webkit-line-clamp: 1
        margin: -3px 0
        span
          margin-right: 21px
          position: relative
          &:before
            content: ''
            position: absolute
            width: 1px
            height: 15px
            commonBgColor(#40444F, #E9E9E9)
            right: -11px
            top: 1px
        &:hover
          color: rgba(250, 122, 80, 1)
          span:before
            background-color: rgba(250, 122, 80, 1)
      .item-last-row
        display: flex
        margin-top: 20px
        justify-content: space-between;
        align-items: flex-end;
        .p2
          font-size:12px
          commonColor(#bcbdc1, #666666)
          display: -webkit-box
          overflow: hidden
          text-overflow: ellipsis
          word-break: break-all
          -webkit-box-orient: vertical
          -webkit-line-clamp: 1
          height: 18px
          line-height: 18px
          margin-right: 10px
          span
            margin-left: 0
            i
              font-size:12px
              margin-right: 4px
            &+span
              margin-left: 20px
        .time
          white-space:nowrap;
          commonColor(#797B83, #999999)
  .article-list
    .article-item
      padding: 20px 0
      display: flex
      &+.article-item
        border-top: 1px solid;
        commonBorderColor(#40444F, #f3f3f3)
      .article
        &-img
          position: relative
          flex: 0 0 212px
          height: 126px
          overflow: hidden
          cursor: pointer
          img
            width: 100%
            height: 100%
            transition_02s()
          &:hover
            img
              transform: scale(1.05, 1.05)
        &-info
          margin-left: 20px
          position: relative
          flex: auto
        &-title
          font-size: 16px;
          commonColor(#ffffff, #333333)
          height: 20px;
          line-height: 20px;
          ellipsis();
          -webkit-line-clamp: 1;
          font-weight: bold;
          cursor: pointer
          &:hover
            color: rgba(250, 122, 80, 1)
        &-summary
          margin-top: 14px;
          font-size: 14px;
          commonColor(#BCBDC1, #666666)
          height: 40px;
          line-height: 20px;
          ellipsis();
          -webkit-line-clamp: 2;
          cursor: pointer
          &:hover
            color: rgba(250, 122, 80, 1)
        &-dec
          position: absolute
          bottom: 0
          width: 100%
          .header-img
            width: 24px
            height: 24px
            border-radius: 12px
            display: inline-block
            vertical-align: top
          .author
          .time
            display: inline-block
            vertical-align: top
            line-height: 24px
            font-size: 12px
            commonColor(#bcbdc1, #666666)
            margin-left: 10px
          .collect_share
            position: absolute
            right: 0
            top: 3px
      >>> .high-light
        color: rgba(250, 122, 80, 1) !important
        font-style: normal
i.s
  width: 18px;
  height: 18px;
  border-radius: 2px;
  font-size: 10px;
  margin-left: 10px;
  background: rgba(250, 122, 80, 1);
  text-align: center;
  line-height: 18px;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
</style>
